export default __webpack_public_path__ + "static/media/close.81f6f019.svg";